import OptOutWizard from '../components/OptOutWizard';
import ApplicationStatus from 'platform/forms/save-in-progress/ApplicationStatus';

// helper module so that we can code split with both of these components
// in the same bundle
export default {
  OptOutWizard,
  ApplicationStatus,
};
